import Vue from "vue";
import Vuex from "vuex";
import storeModerator from "./store-moderator";

Vue.use(Vuex);

const requireModule = require.context("./modules", false, /\w+\.js$/);
const modules = {};

requireModule.keys().forEach(fileName => {
  const config = requireModule(fileName);
  const name = fileName
    .split("/")
    .pop()
    .replace(/\.\w+$/, "");
  const options = config.default || config;

  modules[name] = options;
});

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  plugins: [storeModerator],
  modules
});

// Run the `init` action for namespaced module
export function initStore() {
  for (const moduleName of Object.keys(modules)) {
    if (modules[moduleName].actions.init) {
      store.dispatch(`${moduleName}/init`);
    }
  }
}

export default store;

initStore();
